export default [
  {
    path: "/settings/pricing-and-collections",
    name: "Payment",
    component: () => import("@/views/3pl/Settings/PricingAndCollections/index"),
  },
 
];
 